import useIsWindowGreaterThanWidth from './useIsWindowGreaterThanWidth';

export const TABLET_VIEW_FROM = 1280;

function useIsLaptop(widthProp = TABLET_VIEW_FROM) {
  return !useIsWindowGreaterThanWidth(widthProp);
}

export default useIsLaptop;
